import { router } from '@inertiajs/react'

export abstract class InertiaRouter<TResolve = any> {
  protected pages!: LazyGlobImport<ComponentFile>
  protected layouts!: LazyGlobImport<ComponentFile>

  init({ pages, layouts }: ComponentImports) {
    this.pages = pages
    this.layouts = layouts
  }

  abstract resolve(path: ComponentPath): TResolve

  setup(args: SetupArgs) {}

  getTitle(title?: string) {
    return title ? `${title} - OEE Tools` : 'OEE Tools'
  }

  abstract get AppComponent(): AppComponent

  get appComponentProps(): any {
    return
  }

  get router() {
    return router
  }
}

export type ComponentImports = {
  pages: LazyGlobImport<ComponentFile>
  layouts: LazyGlobImport<ComponentFile>
}

export type SetupArgs = { component: string; props: any }

export type App<TComponent = any> = (props: {
  children: (args: { Component: TComponent; key: any; props: any }) => React.JSX.Element
  [key: string]: any
}) => React.JSX.Element

export type AppComponent<TComponent = any> = (props: {
  App: App<TComponent>
  emotionCache: any
  props: any
}) => React.JSX.Element

export type ComponentPath =
  | { url: string; component?: undefined }
  | { url?: undefined; component: string }

export const isUrlComponentPath = (
  componentPath: ComponentPath,
): componentPath is { url: string; component?: undefined } =>
  typeof (componentPath as any).url === 'string'

export const isComponentPath = (
  componentPath: ComponentPath,
): componentPath is { url?: undefined; component: string } =>
  typeof (componentPath as any).component === 'string'

export type ComponentFile = { default: (props: any) => React.JSX.Element }
export type LazyComponent = React.LazyExoticComponent<(props: any) => React.JSX.Element>

export type LazyGlobImport<T> = Record<string, () => Promise<T>>
export type GlobImport<T> = Record<string, T>
